import { ButtonStyled, ButtonStyledProps } from './styled';

import clsx from 'clsx';

export interface ButtonProps
  extends ButtonStyledProps,
    React.HTMLAttributes<HTMLButtonElement> {
  className?: string;
  children: React.ReactNode;
}

const Button = ({ className, children, ...props }: ButtonProps) => {
  return (
    <ButtonStyled className={clsx('Button', className)} {...props}>
      {children}
    </ButtonStyled>
  );
};

export default Button;
